import type { App } from "vue";

import PrimeVue from "primevue/config";

const primeVueNoThemePlugin = [PrimeVue, { theme: "none" }] as const;
function initPrimeVue(app: unknown) {
  const vueApp = app as App;
  vueApp.use(...primeVueNoThemePlugin);
}

export { initPrimeVue, primeVueNoThemePlugin };
